import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
export interface FormuleBeton {
  id: string;
  name: string;
  description?: string;
  resistance?: string;
  classe_exposition?: string;
  consistance?: string;
  granulometrie?: string;
  prix_unitaire_m3: number;
}

export const useCommandeFormules = (chantierId: string) => {
  const [formules, setFormules] = useState<FormuleBeton[]>([]);
  const [loading, setLoading] = useState(false);
  const fetchFormules = async () => {
    if (!chantierId) return;
    
    setLoading(true);
    try {
      // D'abord, chercher la commande globale du chantier
      const { data: commandeGlobale } = await supabase
        .from('global_orders' as any)
        .select('id')
        .eq('site_id', chantierId)
        .maybeSingle() as any;

      if (commandeGlobale) {
        // Récupérer les formules de la commande globale
        const { data: commandeFormules, error: commandeError } = await supabase
          .from('order_formulas' as any)
          .select('id, name, strength, exposure_class, consistency, granulometry, unit_price_m3')
          .eq('order_id', commandeGlobale.id) as any;

        if (commandeError) throw commandeError;

        if (commandeFormules && commandeFormules.length > 0) {
          const formules: FormuleBeton[] = commandeFormules.map((item: any) => ({
            id: item.id,
            name: item.name,
            description: undefined,
            resistance: item.strength || undefined,
            classe_exposition: item.exposure_class || undefined,
            consistance: item.consistency || undefined,
            granulometrie: item.granulometry || undefined,
            prix_unitaire_m3: item.unit_price_m3
          }));
          setFormules(formules);
          return;
        }
      }

      // Sinon, utiliser les formules génériques de la table concrete_formulas
      const { data: genericFormules, error: genericError } = await supabase
        .from('concrete_formulas' as any)
        .select('id, name, description, strength')
        .order('name')
        .limit(50) as any;

      if (genericError) throw genericError;

      const formules: FormuleBeton[] = genericFormules?.map((item: any) => ({
        id: item.id,
        name: item.name,
        description: item.description || undefined,
        resistance: item.strength || undefined,
        classe_exposition: undefined,
        consistance: undefined,
        prix_unitaire_m3: 100 // Prix par défaut
      })) || [];

      setFormules(formules);
    } catch (error) {
      toast.error("Erreur", { description: "Impossible de charger les formules de béton"});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormules();
  }, [chantierId]);

  return { formules, loading, refetch: fetchFormules };
};